import script from "./knowledgeManage.vue?vue&type=script&setup=true&lang=js"
export * from "./knowledgeManage.vue?vue&type=script&setup=true&lang=js"

import "./knowledgeManage.vue?vue&type=style&index=0&id=2b3994a0&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3994a0"]])

export default __exports__